import Vue from "vue";
import Vuex from "vuex";

import createApp from "@shopify/app-bridge";
import { AppLink, NavigationMenu } from "@shopify/app-bridge/actions";

import api from "./utils/api";

// import Inbox from "./Inbox/index";

Vue.use(Vuex);

const navigationLinks = [
  {
    label: "Automations",
    destination: "/automations"
  },
  {
    label: "Optin",
    destination: "/optin"
  },
  {
    label: "Message Logs",
    destination: "/messagelogs"
  },
  {
    label: "Subscribers",
    destination: "/subscribers"
  }
];

export default new Vuex.Store({
  strict: true,
  state: {
    config: {},
    store: {},
    shopifyPlan: "",
    appBridgeApp: null
  },
  modules: {
    // Inbox,
  },
  mutations: {
    SET_CONFIG: (state, payload) => {
      state.config = payload;
    },
    SET_STORE: (state, payload) => {
      state.store = payload;
    },
    SET_SHOPIFY_PLAN: (state, payload) => {
      state.shopifyPlan = payload;
    },

    updateConfig: (state, payload) => {
      Vue.set(state.config, payload.key, payload.value);
    },

    SET_APP_BRIDGE_APP(state, payload) {
      state.appBridgeApp = payload;
    }
  },
  getters: {
    getConfig: state => state.config,
    getStore: state => state.store,
    getShopifyPlan: state => state.shopifyPlan,
    getAppBridgeApp: state => state.appBridgeApp
  },
  actions: {
    getConfig(context) {
      return api.get(`shopify/config`).then(response => {
        context.commit("SET_CONFIG", response.config);
        context.commit("SET_STORE", response.store);
        context.commit("SET_SHOPIFY_PLAN", response.shopifyPlan);
        return response;
      });
    },
    updateConfig(context, payload) {
      return api.put(`shopify/config`, payload.requestParams).then(response => {
        context.commit("SET_CONFIG", response.config);
        return response;
      });
    },
    getAutomationConfig() {
      return api.get(`automation/`);
    },
    updateAutomationConfig(context, payload) {
      return api.put(`automation/`, payload.requestParams);
    },
    getOptinConfig() {
      return api.get(`widget/`);
    },
    updateOptinConfig(context, payload) {
      return api.put(`widget/`, payload.requestParams);
    },
    getSubscribers(context, payload) {
      return api.get(`subscriber/?page=${payload.page}`);
    },
    getMessageLog(context, payload) {
      return api.get(`automation/messagelog/?page=${payload.page}`);
    },
    updateOnboardingFlag(context, payload) {
      return api
        .post(`shopify/onboardingflags`, payload.requestParams)
        .then(response => {
          context.commit("SET_CONFIG", response.config);
        });
    },

    getUser() {
      return api.get(`shopify/user`);
    },

    getAnalytics(context, payload) {
      return api.get(
        `report/analytics?startDate=${payload.startDate}&endDate=${payload.endDate}`
      );
    },
    showNotification(context, payload) {
      const event = new CustomEvent("ToastNotify", {
        detail: { text: payload.text }
      });
      window.dispatchEvent(event);
    },

    initAppBridge(context) {
      const host = new URLSearchParams(location.search).get("host");
      if (host) {
        const config = {
          apiKey: process.env.VUE_APP_SHOPIFY_API_KEY,
          host,
          forceRedirect: false
        };
        const app = createApp(config);
        window.appBridgeApp = app;
        context.commit("SET_APP_BRIDGE_APP", app);
        console.log("app bridge intialized");
        const appLinks = [];
        for (const navLink of navigationLinks) {
          const appLink = AppLink.create(app, {
            label: navLink.label,
            destination: navLink.destination
          });
          appLinks.push(appLink);
        }
        NavigationMenu.create(app, {
          items: appLinks
        });
        return app;

        // app.subscribe(Redirect.Action.APP, redirectData => {
        //   console.log(redirectData.path); // For example, '/settings'
        //   this.$router.push({ path: redirectData.path });
        // });
      }
    }
  }
});
